<nz-form-control *ngIf="recordProperty !== undefined">
  <nz-date-picker [nzDisabledDate]="disabledDate" [nzShowToday]="false" [nzDisabled]="!notLoading" [class]="parentClass"
    [nzAllowClear]="allowClearDate" [nzMode]="field.AdditionalInformationParsed.IsDatePickerMonthMode ? 'month': '' "
    [(ngModel)]="recordProperty.ValueAsObject" [ngModelOptions]="{ updateOn: 'blur'}"
    (ngModelChange)="dateValueChanged();" [nzDisabled]="recordProperty.ReadOnly" [nzFormat]="dateFormat"
    (nzOnOpenChange)="onOpenChange()">
  </nz-date-picker>
  <ng-template #tplRender let-current>
    <div class="ant-picker-cell-inner" [class.border]="current.getDate() === 1">
      {{ current.getDate() }}
    </div>
  </ng-template>
</nz-form-control>
